
import { mixins } from 'vue-class-component';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import FormInput from '@/components/form/FormInput.vue';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import { InviteInformation } from '@/model/Project';
import { emailLocalPartMaxLength } from '@/mixins/validations/email-validation';

@Component({
    components: {
        FormInput,
    },
})
export default class EventEditorInviteForm extends mixins(FormValidationMixin) {
    @Prop() eventId!: number;

    @Prop() loading!: boolean;

    submitted = false;

    formData = {
        email: '',
    };

    @Validations()
    validations = {
        formData: {
            email: {
                required,
                email,
                maxLength: maxLength(80),
                localPartMaxLength: (value: string): boolean =>
                    emailLocalPartMaxLength(value),
            },
        },
    };

    onSubmit(): void {
        this.submitted = true;
        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }

    @Emit('submit')
    submit(): InviteInformation {
        return {
            email: this.formData.email,
            eventIds: [this.eventId],
        };
    }
}
